var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-question u-row u-center u-middle"},[_c('div',{staticClass:"label-question__text u-full-width"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }